import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip } from "recharts";

/**
 * Small wrapper around Recharts to draw the 8-dimension radar with Ariovis brand colors.
 * data: [{ dim, label, score }]
 */
export default function DimensionRadar({ data, height = 320 }) {
    return (
        <div className="w-full" style={{ height }} data-testid="dimension-radar">
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart data={data} outerRadius="72%">
                    <PolarGrid stroke="#cbd5e1" />
                    <PolarAngleAxis dataKey="label" tick={{ fill: "#334155", fontSize: 11 }} />
                    <PolarRadiusAxis angle={30} domain={[0, 5]} tick={{ fill: "#94a3b8", fontSize: 10 }} />
                    <Radar
                        name="Score"
                        dataKey="score"
                        stroke="#9E0E40"
                        fill="#DE0F72"
                        fillOpacity={0.28}
                        strokeWidth={2}
                        isAnimationActive={true}
                    />
                    <Tooltip
                        contentStyle={{
                            background: "#0f172a",
                            border: "none",
                            color: "#f8fafc",
                            fontFamily: "'Bai Jamjuree', sans-serif",
                            fontSize: 12,
                            borderRadius: 4,
                        }}
                        formatter={(value) => [`${Number(value).toFixed(1)} / 5`, "Score"]}
                    />
                </RadarChart>
            </ResponsiveContainer>
        </div>
    );
}
